export class MilestoneResponse {
    igsCustomerNumber: string;
    approved: boolean;
    rejectionReason: string;
    upload: File;
}